import { StackSection } from "@origin-digital/ods-core";
import React from "react";
import { ContentSection } from "./ContentSection";

export const LandingPageShell: React.FC = () => (
  <StackSection
    hideGutter={{ xs: true, sm: false }}
    backgroundColor="cardBackground"
    data-id="help-support-landing-page"
    width="xlarge"
    space="none"
    paddingY={"none"}
  >
    <ContentSection />
  </StackSection>
);
